package kz.dentalcrm.app.core.ui.components

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.runtime.Composable
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonColors
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.Text
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import kz.dentalcrm.app.theme.DefaultTheme

@Composable
fun UIButton(
    text: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    contentPadding: PaddingValues = PaddingValues(horizontal = 24.dp, vertical = 12.dp),
    enabled: Boolean = true,
    containerColor: Color = DefaultTheme.colors.primary,
    style: TextStyle = DefaultTheme.typography.bodyMediumMedium,
    contentColor: Color = DefaultTheme.colors.onPrimary,
    disabledContainerColor: Color = DefaultTheme.colors.surfaceTertiary,
    disabledContentColor: Color = DefaultTheme.colors.onSurfaceVariant,
    progressColor: Color = DefaultTheme.colors.onPrimary,
    shape: RoundedCornerShape = RoundedCornerShape(16.dp),
    isLoading: Boolean = false
) {
    Button(
        modifier = modifier.fillMaxWidth(),
        onClick = onClick,
        contentPadding = contentPadding,
        enabled = enabled,
        colors = ButtonColors(
            containerColor = containerColor,
            contentColor = contentColor,
            disabledContainerColor = disabledContainerColor,
            disabledContentColor = disabledContentColor
        ),
        shape = shape,
        elevation = null,
    ) {
        if (isLoading) {
            CircularProgressIndicator(
                color = progressColor,
                modifier = Modifier.size(20.dp),
                strokeWidth = 3.dp
            )
        } else {
            Text(
                modifier = Modifier,
                textAlign = TextAlign.Center,
                text = text,
                style = style,
                color = LocalContentColor.current
            )
        }
    }
}